import * as React from "react";
import { BusinessReportOutcome } from "@/modules/snapshots/businessReports.types";
import { EyeIcon, MessageSquareIcon } from "lucide-react";
import { Link, useParams } from "react-router";
import { Button } from "@/components/ui/button";
import { useToggle } from "react-use";
import { BusinessReportOutcomeDeleteModal } from "@/modules/snapshots/modals/businessReportOutComeDeleteModal";

interface Props {
  businessReportOutcome: BusinessReportOutcome;
}

export const GridSidebarSearchRowActions: React.FC<Props> = ({ businessReportOutcome }) => {
  const { businessReport, collectionId } = useParams<{ businessReport: string; collectionId: string }>();
  const [showRemoveModal, setShowRemoveModal] = useToggle(false);
  if (!businessReportOutcome.fs_entry) {
    return null;
  }
  return (
    <>
      <BusinessReportOutcomeDeleteModal
        businessReportOutcome={businessReportOutcome}
        isOpen={showRemoveModal}
        setIsOpen={setShowRemoveModal}
      />
      <div className="flex justify-end pr-2">
        <Link to={`/reports/outcome/${businessReportOutcome.id}`} title="View SnapShot">
          <Button
            disabled={businessReportOutcome.status === "NEW"}
            variant="second-white"
            size="sm"
            className="mr-1 flex items-center gap-2 px-3 py-2 text-xs"
            type="button"
          >
            <EyeIcon className="h-4 w-4 flex-shrink-0" />
          </Button>
        </Link>

        <Button variant="second-white" size="sm" className="w-full text-xs sm:w-auto" asChild>
          <Link
            to={`/chat/${businessReportOutcome.fs_entry.id}`}
            title="Q&A"
            state={{
              fromSnapshot: `/snapshots/grid/${businessReport}/${collectionId}?outcomeId=${businessReportOutcome.id}`,
            }}
          >
            <MessageSquareIcon className="h-4 w-4" />
          </Link>
        </Button>
      </div>
    </>
  );
};
